import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Typography, MenuItem, Menu } from '@mui/material';
import { ListItemIcon, ListItemText, Divider, Button, Avatar, IconButton } from '@mui/material';
import { Stack, Grid, useMediaQuery, Chip, CircularProgress, Paper, Collapse } from '@mui/material';
import { useTheme, RadioGroup, Card, FormControlLabel, Radio, Tooltip } from '@mui/material';
import { Accordion, AccordionSummary, AccordionDetails, CardActionArea } from '@mui/material';
import { DashboardRounded } from '@mui/icons-material';
import { HomeRounded } from '@mui/icons-material';
import { ShoppingBasketRounded } from '@mui/icons-material';
import { KeyboardArrowDownRounded } from '@mui/icons-material';
import { StarBorderRounded } from '@mui/icons-material';
import { ArrowDropDown } from '@mui/icons-material';
import { FormIcon, AuditIcon, ProcessIcon, TaskIcon, RegistersIcon, AddIcon, HomeIcon } from '../Global/Icons';
import { Tags } from '../Global/Components';
import { Scrollbar } from '../scrollbar';
import SupportDialog from '../Support/components/SupportDialog';
import { NewUserDialog } from '../AdminPanel/pages/Users/index';
import { GroupDialog } from '../AdminPanel/pages/Groups/index';
import WorkspaceDialog from '../Hubs/tasks/workspaces/components/WorkspaceDialog';
import { PostItemHorizontal } from '../Support/components/post-item-horizontal';
import { useHistory } from 'react-router-dom';
import DrawerLayout from '../Global/DrawerLayout';
import { green, grey, purple, yellow, amber } from '@mui/material/colors';
import axios from 'axios';
import StateManager from '../Global/StateManager';
import Dashboard from '../Hubs/tasks/workspaces/components/Dashboard';
import Folder from '../Hubs/tasks/workspaces/components/Folder';
import { styled, alpha } from '@mui/material/styles';
import { isArray, isEmpty, first, setWith } from 'lodash';
import { AppWelcome } from './app-welcome';
import SeoIllustration from '../../assets/illustrations/seo-illustration';
import { Carousel, useCarousel, CarouselArrowBasicButtons } from '../carousel';
import ResourceSearch from '../Hubs/resources/components/ResourceSearch';
import ResourceDialog from '../Hubs/resources/components/ResourceDialog';
import { Metrics } from '../Hubs/resources/components/Metrics';
import TableView from '../Hubs/tasks/TaskView/views/TableView';
import YouTubeModal from '../Support/components/YoutubeModal';
import moment from 'moment';

const homePageVideo = 'https://www.youtube.com/watch?v=RCdUiUDnkW4&list=PLHDh1wHtJ91KV0OiMAYUt9ak3F-E9DOHy';
const homepageVideoId = 'bf31c493-e540-4c22-bc6f-86e95012b429';

const mock = {
  tasks: { title: 'My Tasks', total: 50, icon: <TaskIcon />, color: purple[400], percent: 50, overdue: 12 },
  form: { title: 'My Form', total: 50, icon: <FormIcon />, color: green[400], percent: 50, overdue: 12 },
  process: { title: 'My Process', total: 50, icon: <ProcessIcon />, color: yellow[400], percent: 50, overdue: 12 },
};

const StyledTile = styled(Paper)(({ theme }) => ({
  borderRadius: theme.spacing(1.5),
  boxShadow: theme.shadows[2],
  transition: theme.transitions.create(['box-shadow', 'transform'], {
    duration: theme.transitions.duration.short,
  }),
  '&:hover': {
    boxShadow: theme.shadows[6],
    transform: 'translateY(-2px)',
  },
  width: '650px',
  height: '250px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
}));

const TitleContainer = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(2),
  flexGrow: 1,
  overflow: 'hidden',
}));

export default function Home() {
  const theme = useTheme();

  const { user } = useSelector(({ profile }) => profile);
  const userAccess = user?.access || false;
  const largeDevices = useMediaQuery(theme.breakpoints.up('sm'));
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [dashboard, setDashboard] = useState(null);
  const [folder, setFolder] = useState(null);
  const [availableDashboards, setAvailableDashboards] = useState([]);
  const [loadingDashboard, setLoadingDashboard] = useState(false);
  const [selectedDashboardId, setSelectedDashboardId] = useState(null);
  const [companyData, setCompanyData] = useState([]);
  const [tasksStat, setTasksStat] = useState(null);
  const [formStat, setFormStat] = useState(null);
  const [processStat, setProcessStat] = useState(null);
  const [views, setViews] = useState(null);
  const [menuAnchor, setMenuAnchor] = useState(false);
  const [display, setDisplay] = useState('dashboard');
  const [workSpaceDialog, setWorkspaceDialog] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [dashboardItems, setDashboardItems] = useState([]);
  const [dashboardLayouts, setDashboardLayouts] = useState({});

  const selectedWorkspace = selectedDashboardId ? availableDashboards.find((x) => x._id === selectedDashboardId) : null;

  useEffect(() => {
    axios
      .get('/user/getUserHomePage')
      .then(({ data }) => {
        setDashboard(data.dashboard);
        setSelectedDashboardId(data.homeDashboardId || data.companyDefaultHomepage || null);
        setFolder(data.rootFolder || null);
        setDisplay(data.homeFolderId ? 'folder' : 'dashboard');
        setAvailableDashboards(data.availableDashboards); //Available dashboards
        setCompanyData(data.companyInfo || null);
        setTasksStat(data.taskStat || null);
        setFormStat(data.formStat || null);
        setProcessStat(data.processStat || null);
        setViews(data.views || null);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }, []);

  function saveUserHomePage(homeDashboardId, homeFolderId) {
    if (homeDashboardId) {
      setLoadingDashboard(true);
    } else {
      setDashboard(null);
    }
    axios
      .post('/user/saveUserHomePage', { homeDashboardId, homeFolderId })
      .then((res) => {
        setDashboard(res.data.dashboard || null);
        setFolder(res.data.rootFolder);
        setSelectedDashboardId(res.data.homeDashboardId || null);
        setLoadingDashboard(false);
      })
      .catch((err) => {
        StateManager.setAxiosErrorAlert(err);
        setLoadingDashboard(false);
      });
  }

  const drawerItems = availableDashboards?.length
    ? [
        {
          title: 'Default homepage',
          icon: <HomeIcon />,
          selectedIcon: <HomeIcon />,
          onClick: () => {
            setSelectedDashboardId(null);
            saveUserHomePage(null, null);
          },
          selected: !selectedDashboardId,
        },
        ...availableDashboards.map((dashboard) => ({
          title: dashboard.title,
          icon: <DashboardRounded />,
          selectedIcon: <DashboardRounded />,
          selected: selectedDashboardId === dashboard._id,
          onClick: () => {
            setSelectedDashboardId(dashboard._id);
            saveUserHomePage(dashboard._id, display === 'folder' ? dashboard.rootFolderId : null);
          },
        })),
      ]
    : [
        {
          title: 'Default homepage',
          icon: <HomeIcon />,
          selectedIcon: <HomeIcon />,
          onClick: () => {
            setSelectedDashboardId(null);
            saveUserHomePage(null, null);
          },
        },
      ];

  const drawerSections = {
    menuContent: [
      {
        title: 'New Workspace',
        icon: <AddIcon />,
        hidden: userAccess !== 'admin' && userAccess !== 'manager',
        onClick: () => setWorkspaceDialog(true),
      },
    ],
    sections: [{ items: [...drawerItems] }],
  };
  const dashboardMenu = (
    <>
      {selectedWorkspace && (
        <RadioGroup
          value={display}
          onChange={(e) => {
            setDisplay(e.target.value);
            saveUserHomePage(
              selectedWorkspace._id,
              e.target.value === 'folder' ? selectedWorkspace.rootFolderId : null,
            );
          }}
          row
        >
          {' '}
          {dashboard?.createdBy === user?._id && (
            <Button onClick={() => history.push(`/tasks/workspaces/${dashboard?._id}`)}>Edit dashboard</Button>
          )}
          <FormControlLabel value={'dashboard'} label={'Dashboard'} control={<Radio />} />
          <FormControlLabel value={'folder'} label={'Folder'} control={<Radio />} />
        </RadioGroup>
      )}

      <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={() => setMenuAnchor(null)}>
        {availableDashboards.map((item) => (
          <MenuItem
            key={item._id}
            onClick={() => {
              setMenuAnchor(null);
              setSelectedDashboardId(item._id);
              saveUserHomePage(item._id, display === 'folder' ? item.rootFolderId : null);
            }}
          >
            <ListItemIcon>
              <DashboardRounded style={{ color: grey[500] }} />
            </ListItemIcon>
            <ListItemText>
              <Typography style={{ fontWeight: selectedDashboardId === item._id ? 600 : 400 }}>{item.title}</Typography>
            </ListItemText>
          </MenuItem>
        ))}
        <MenuItem
          onClick={() => {
            setMenuAnchor(null);
            setSelectedDashboardId(null);
            saveUserHomePage(null, null);
          }}
        >
          <ListItemIcon>
            <HomeRounded style={{ color: grey[500] }} />
          </ListItemIcon>
          <ListItemText>
            <Typography style={{ fontWeight: selectedDashboardId === null ? 600 : 400 }}>Standard home page</Typography>
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  );

  return (
    <DrawerLayout title="Home" hub="home" drawerContent={drawerSections} fillHeight>
      {loading ? (
        <Grid container style={{ height: '80vh' }}>
          <CircularProgress style={{ margin: 'auto' }} />
        </Grid>
      ) : error ? (
        <Grid container style={{ height: '80vh' }} justifyContent="center" alignItems="center">
          <Typography color={'textSecondary'} variant="h6">
            Failed to load the home page
          </Typography>
        </Grid>
      ) : (
        <Grid container alignItems="flex-start" className="scroll-bar">
          <Grid container item sx={{ px: 1 }}>
            {loadingDashboard ? (
              <Grid container item justifyContent="center" alignItems="center">
                <CircularProgress color="primary" size={30} />
              </Grid>
            ) : dashboard ? (
              <Grid container item justifyContent="center" alignItems="center">
                <Grid container item>
                  <Typography variant="h4">{dashboard.title}</Typography>
                  <div style={{ marginLeft: 'auto' }} />
                  {dashboardMenu}
                </Grid>
                <Grid container item sx={{ mt: folder ? 2 : 0, width: '100%' }}>
                  {folder ? (
                    <Folder initial={folder} readOnly />
                  ) : (
                    <Dashboard initialItems={dashboard.dashboardItems} initialLayouts={dashboard.dashboardLayouts} />
                  )}
                </Grid>
              </Grid>
            ) : (
              <DefaultHomePage
                tasksStat={tasksStat}
                formStat={formStat}
                processStat={processStat}
                views={views}
                user={user}
                companyData={companyData}
                largeDevices={largeDevices}
              />
            )}
          </Grid>
        </Grid>
      )}
      <WorkspaceDialog
        open={workSpaceDialog}
        onClose={() => setWorkspaceDialog(false)}
        onResult={(data) => history.push(`/tasks/workspaces/${data._id}`)}
      />
    </DrawerLayout>
  );
}

function DefaultHomePage({ tasksStat, formStat, processStat, user, companyData, views, largeDevices }) {
  const [newUserDialog, setNewUserDialog] = useState(false);
  const [groupDialog, setGroupDialog] = useState(false);
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [newTicket, setNewTicket] = useState(false);
  const [workspaceDialog, setWorkspaceDialog] = useState(false);
  const [currResource, setCurrResource] = useState({});
  const [resourceDialog, setResourceDialog] = useState(false);
  const [featuredItems, setFeaturedItems] = useState([]);
  const [taskInfo, setTaskInfo] = useState([]);
  const [posts, setPosts] = useState([]);
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialVideo, setInitialVideo] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const history = useHistory();

  useEffect(() => {
    axios
      .get('/resources/public/getRootFolder')
      .then(({ data }) => {
        setFeaturedItems(isArray(data?.items) ? data.items.filter((x) => x.featured) : []);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    axios
      .get('/tasks/data/getMyTasksInfo')
      .then(({ data }) => {
        setTaskInfo(data);
      })
      .catch((err) => {
        StateManager.setAxiosErrorAlert(err);
      });
  }, []); // eslint-disable-line

  useEffect(() => {
    axios.get('/help/getVideoForHomepage').then((data) => {
      setPosts(data.data.videos);
      setTags(data.data.tags);
      setInitialVideo(!user?.watchedVideos?.includes(homepageVideoId));
    });
  }, []); //eslint-disable-line

  function saveCompany(update) {
    axios
      .post(`admin/company`, update)
      .then(() => {
        StateManager.setSuccessAlert('Company has been updated');
      })
      .catch((err) => {
        StateManager.setAxiosErrorAlert(err);
      });
  }

  function loadResource(resourceId) {
    setLoading(true);
    axios
      .get('/resources/public/getResource', { params: { resourceId } })
      .then(({ data }) => {
        setCurrResource(data);
        setResourceDialog(true);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }

  const categories = [
    'All videos',
    'Tutorial videos',
    'Use cases',
    'Features',
    'Customer examples',
    'Updates',
    'Podcasts',
  ];

  function uploadLogo(event) {
    let file = event.target.files[0];
    if (!file || !file.type?.startsWith('image/') || uploadingLogo) return;
    setUploadingLogo(true);
    const data = new FormData();
    data.append('file', file);
    axios
      .post(`/uploader/upload-single`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then((res) => {
        saveCompany({ logo: res.data.file.location });
      })
      .catch((err) => {
        StateManager.setAxiosErrorAlert(err);
      })
      .finally(() => {
        setUploadingLogo(false);
      });
  }

  const carousel = useCarousel({
    align: 'start',
    slideSpacing: '24px',
    slidesToShow: {
      xs: 1,
      sm: 2,
      md: 3,
      lg: 4,
    },
  });

  const carouselResource = useCarousel({
    align: 'start',
    slideSpacing: '24px',
    slidesToShow: {
      xs: 1,
      sm: 2,
      md: 3,
      lg: 4,
    },
  });

  return (
    <Grid
      container
      item
      direction="column"
      sx={{
        display: 'flex',
        minHeight: '100vh',
        flexWrap: 'nowrap',
      }}
    >
      <AppWelcome
        title={`Hi ${user?.fullName}!`}
        tile={`Today is ${moment().format('dddd, DD/MM/YYYY')}`}
        img={
          user?.picture256 ? (
            <Avatar src={user?.picture256} sx={{ width: '125px', height: '125px' }} />
          ) : (
            <SeoIllustration
              hideBackground
              sx={{ justifyContent: 'flex-start', maxHeight: '100px', width: '100px', px: 1 }}
            />
          )
        }
        sx={{ maxHeight: '100px', width: '100%', flexDirection: 'column', mt: '25px', mb: '10px' }}
      />
      {user?.access === 'admin' && (
        <>
          <Grid container item sx={{ mt: 0.5 }} py={1}>
            <Accordion
              sx={{
                alignItems: 'center',
                width: '100%',
                backgroundColor: 'background.paper',
                boxShadow: (theme) => theme.shadows[2],
              }}
            >
              <AccordionSummary
                expandIcon={<KeyboardArrowDownRounded />}
                aria-controls="panel1-content"
                id="panel1-header"
                sx={{ alignItems: 'center' }}
              >
                <Typography sx={{ fontWeight: 500, display: 'flex', alignItems: 'center' }}>Admin</Typography>
                <Grid container item width={'100%'} justifyContent={'space-around'} alignItems={'center'}>
                  <Chip
                    variant="soft"
                    label={`Access expires at ${moment(companyData?.endTrial).format('DD/MM/YYYY')}`}
                  />
                  <Chip variant="soft" label={`Package: ${companyData?.status || 'Not chosen'}`} />
                  <Chip variant="soft" label={`Admins: ${companyData?.purchasedUsers || '0'} `} />
                  <Chip variant="soft" label={`Basic: ${companyData?.purchasedBasicUsers || '0'}`} />
                  <Button variant="soft" onClick={() => history.push('/admin')}>
                    Go to admin panel
                  </Button>
                </Grid>
              </AccordionSummary>

              <AccordionDetails>
                <Grid container item sx={{ width: '100%', alignItems: 'center', gap: 1, nb: 5 }}>
                  <Typography>Quick actions: </Typography>
                  <Button variant="soft" onClick={() => setNewUserDialog(true)}>
                    Add a user
                  </Button>
                  <Button variant="soft" onClick={() => setGroupDialog(true)}>
                    Add a group
                  </Button>

                  <Button variant="soft" component="label">
                    <input
                      accept="image/*"
                      name="img"
                      id="cover-photo"
                      type="file"
                      style={{ display: 'none' }}
                      onChange={uploadLogo}
                    />
                    Edit company logo
                  </Button>
                  <Button variant="soft" onClick={() => setNewTicket(true)}>
                    Raise a ticket
                  </Button>
                  <Button variant="soft" onClick={() => setWorkspaceDialog(true)}>
                    Add a workspace
                  </Button>
                </Grid>
                <Grid container item direction={'column'} sx={{ width: '100%', alignItems: 'center', gap: 1, mt: 5 }}>
                  <Grid container item direction={'row'}>
                    <Typography>Essentional videos: </Typography>
                    <CarouselArrowBasicButtons {...carousel.arrows} />
                    <Button variant="soft" onClick={() => history.push('/help/videos')}>
                      Show more
                    </Button>
                  </Grid>
                  <Carousel carousel={carousel}>
                    {posts.map((post, id) => (
                      <PostItemHorizontal key={`post${id}`} post={post} tags={tags} categories={categories} />
                    ))}
                  </Carousel>
                </Grid>
              </AccordionDetails>
            </Accordion>
            <NewUserDialog
              open={newUserDialog}
              onClose={() => setNewUserDialog(false)}
              onResult={() => console.log('User successfuly added')}
            />
            {/*Without console.log throw an error*/}
            <GroupDialog
              open={groupDialog}
              onClose={() => setGroupDialog(false)}
              onResult={() => console.log('Group successfuly added')}
            />
            <SupportDialog open={newTicket} onClose={() => setNewTicket(false)} />
            <WorkspaceDialog
              open={workspaceDialog}
              onClose={() => setWorkspaceDialog(false)}
              onResult={(data) => history.push(`/tasks/workspaces/${data._id}`)}
            />
            <ResourceDialog open={resourceDialog} onClose={() => setResourceDialog(false)} resource={currResource} />
          </Grid>

          <Grid container item my={1} component={Paper}>
            <Grid container item wrap="nowrap" sx={{ width: '100%', alignItems: 'center', gap: 1, py: 1, px: 2 }}>
              <Typography wrap={'nowrap'} sx={{ mr: 2 }}>
                Resources:
              </Typography>
              <ResourceSearch onResourceSelect={(item) => loadResource(item.id)} />
              <Tooltip title={resourcesOpen ? 'Show less' : 'Show more'}>
                <IconButton
                  sx={{
                    ml: 2,
                    transform: 'rotate(0deg)',
                    transition: (theme) =>
                      theme.transitions.create('transform', {
                        duration: theme.transitions.duration.shortest,
                      }),
                    transform: resourcesOpen ? 'rotate(180deg)' : null,
                  }}
                  onClick={() => setResourcesOpen(!resourcesOpen)}
                >
                  <KeyboardArrowDownRounded />
                </IconButton>
              </Tooltip>
            </Grid>

            <Grid container component={Collapse} in={resourcesOpen}>
              <Grid container item sx={{ alignItems: 'center', gap: 1, mt: 5, py: 1, px: 2 }}>
                <Typography>Popular resources: </Typography>
                {!isEmpty(featuredItems) && <CarouselArrowBasicButtons {...carouselResource.arrows} />}
                <Button variant="soft" onClick={() => history.push('/resources')}>
                  Show more
                </Button>
                {isEmpty(featuredItems) ? (
                  <Grid container sx={{ my: 1 }}>
                    <Typography>No featured recources available</Typography>
                  </Grid>
                ) : (
                  <Grid container>
                    <Carousel
                      carousel={carouselResource}
                      sx={{
                        width: '100%',
                        display: 'flex',
                        gap: '2.5px',
                      }}
                      slotProps={{ container: { width: '100%' } }}
                    >
                      {featuredItems.map((item) => (
                        <ItemTile
                          key={item._id}
                          item={item}
                          featured
                          sx={{ display: 'flex' }}
                          onClick={(id) => {
                            loadResource(id);
                          }}
                        />
                      ))}
                    </Carousel>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
      <Grid container component={Paper} sx={{ mb: { xs: 2, md: 2 }, alignItems: 'center', mt: 1, minHeight: '135px' }}>
        <Scrollbar
          sx={{
            '& .simplebar-placeholder': {
              display: 'none',
            },
          }}
        >
          <Stack
            divider={<Divider orientation="vertical" flexItem sx={{ borderStyle: 'dashed' }} />}
            sx={{ py: 2, flexDirection: 'row' }}
          >
            <Metrics
              title={tasksStat?.title}
              total={tasksStat?.total}
              percent={tasksStat?.percent}
              overdue={tasksStat?.overdue}
              dueToday={tasksStat?.dueToday}
              icon="solar:case-round-minimalistic-bold-duotone"
              color={purple[400]}
            />

            <Metrics
              title={formStat?.title}
              total={formStat?.total}
              percent={formStat?.percent}
              overdue={formStat?.overdue}
              dueToday={formStat?.dueToday}
              icon="solar:clipboard-list-bold-duotone"
              color={green[400]}
            />

            <Metrics
              title={processStat?.title}
              total={processStat?.total}
              percent={processStat?.percent}
              overdue={processStat?.overdue}
              dueToday={processStat?.dueToday}
              icon="solar:cpu-bolt-line-duotone"
              color={mock.process.color}
            />
          </Stack>
        </Scrollbar>
      </Grid>
      <Grid container component={Paper} sx={{ mb: { xs: 2, md: 2 }, alignItems: 'center', p: 2, minHeight: '140px' }}>
        <Typography textAlign={'flex-start'}>Recently visited: </Typography>
        <Scrollbar
          sx={{
            width: '100%',
            '& .simplebar-placeholder': {
              display: 'none',
            },
          }}
        >
          <Grid container item direction={largeDevices ? 'row' : 'column'} wrap="nowrap" gap={1} p={1}>
            {!views?.length ? (
              <Typography variant={'body2'} color={'textSecondary'} textAlign={'flex-start'}>
                Try your first Q-Hub Feature!
              </Typography>
            ) : (
              views?.map((view, id) => <RecentlyUsedItem key={`v${id}`} item={view} sx={{ maxwidth: '100%' }} />)
            )}
          </Grid>
        </Scrollbar>
      </Grid>
      <Grid
        direction={'column'}
        container
        component={Paper}
        sx={{
          p: 2,
          display: 'flex',
          flexGrow: 1,
          minHeight: '600px',
          flexWrap: 'nowrap',
        }}
      >
        <Typography textAlign={'flex-start'}>My work: </Typography>
        <Grid
          item
          container
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <TableView pageType="my" taskInfo={taskInfo} forHomePage />
        </Grid>
      </Grid>
      {/* <YouTubeModal
        open={initialVideo}
        onClose={() => setInitialVideo(false)}
        videoUrl={homePageVideo}
        post={{ _id: homepageVideoId }}
        canClose={false}
      /> need a Video */}
    </Grid>
  );
}

function ItemTile({ item, onClick, featured, ...props }) {
  const hasImages = isArray(item?.pictures) && !isEmpty(item.pictures);
  const icon = hasImages ? first(item.pictures) : null;

  const StyledTile = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '400px',
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    boxShadow: theme.shadows[1],
  }));

  const IconContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100%',
    height: '200px',
    backgroundColor: theme.palette.grey[800],
    flexShrink: 0,
  }));

  const StyledImage = styled('img')({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  });

  const TitleContainer = styled('div')(({ theme }) => ({
    flexGrow: 1,
    padding: theme.spacing(1.5),
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  }));

  return (
    <StyledTile {...props}>
      <CardActionArea
        onClick={() => onClick(item._id)}
        sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}
      >
        <IconContainer>
          {icon ? (
            <StyledImage src={icon.location} alt="icon" />
          ) : (
            <ShoppingBasketRounded fontSize="medium" sx={{ color: 'white' }} />
          )}
        </IconContainer>
        <TitleContainer>
          <Grid container alignItems="flex-start" justifyContent="flex-start">
            {featured && (
              <StarBorderRounded
                sx={{
                  color: amber[600],
                  mr: 1,
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': { transform: 'scale(1.2)' },
                }}
              />
            )}
            <Typography
              variant="h6"
              sx={{
                lineHeight: 1.4,
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textAlign: 'left',
                maxWidth: '100%',
                wordWrap: 'break-word',
              }}
            >
              {item?.title || 'Untitled'}
            </Typography>
          </Grid>

          {featured && item?.briefDescription && (
            <Grid item container sx={{ mt: 0.5, width: '100%' }} justifyContent="flex-start">
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{
                  lineHeight: 1.4,
                  display: '-webkit-box',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textAlign: 'left',
                  maxWidth: '100%',
                  wordWrap: 'break-word',
                }}
              >
                {item.briefDescription}
              </Typography>
            </Grid>
          )}

          {!isEmpty(item?.tags) && isArray(item.tags) && (
            <Grid item container sx={{ mt: 1, width: '100%' }} justifyContent="flex-start">
              <Tags
                justifyContent="flex-start"
                tags={item.tags}
                chipProps={{ size: 'small', variant: 'outlined', color: 'default' }}
                typographyProps={{
                  variant: 'caption',
                  color: 'textSecondary',
                  sx: {
                    maxWidth: '100%',
                    wordWrap: 'break-word',
                  },
                }}
              />
            </Grid>
          )}
        </TitleContainer>
      </CardActionArea>
    </StyledTile>
  );
}
function RecentlyUsedItem({ item, props }) {
  const history = useHistory();
  const title = !item?.lookupData.length
    ? 'Deleted object'
    : item?.targetType === 'processEntry' || item?.targetType === 'formEntry'
    ? `Entry #${item?.lookupData[0].number} ${item?.lookupData[0].title}`
    : item?.lookupData[0].title;

  const icons = {
    task: <TaskIcon />,
    form: <FormIcon />,
    process: <ProcessIcon />,
    register: <RegistersIcon />,
    audit: <AuditIcon />,
  };

  const links = {
    audit: `/audits/${item?.targetId}`,
    formEntry: `/forms/entry/${item?.targetId}`,
    formInfo: `/forms/${item?.targetId}`,
    processEntry: `/processes/ongoing/${item?.targetId}`,
    processInfo: `/processes/${item?.targetId}`,
    register: `/registers/${item?.targetId}`,
  };

  return (
    <Tooltip title={title}>
      <StyledTile
        sx={{ display: 'flex', flex: 1, maxHeight: '60px' }}
        onClick={() => history.push(links[item.targetType])}
        {...props}
      >
        <CardActionArea sx={{ maxHeight: '60px' }}>
          <Grid container alignItems="center" wrap="nowrap" sx={{ paddingLeft: 2 }}>
            {icons[item?.hub] || null}
            <TitleContainer>
              <Grid container alignItems="center" wrap="nowrap" sx={{ heigh: 'fit-content' }}>
                <Typography variant="h6" noWrap>
                  {title || 'Untitled'}
                </Typography>
              </Grid>
            </TitleContainer>
          </Grid>
        </CardActionArea>
      </StyledTile>
    </Tooltip>
  );
}
